import React from 'react';
import { Content, Title } from 'bloomer';

const Login = () => {
    return (
        <>
            <br />
            <Title isSize={4}>Login Page</Title>
            <br />
            <Content>
                <p>Use the login button at the top right to login with Google.</p>
                <p>Additional login methods coming soon.</p>
            </Content>
            
        </>
    )
}

export default Login;